import {
  resolveSessionPassTheme,
  type SessionPassTheme,
} from '@/features/session-pass/style-profile';
import type { CustomerSessionPassData } from './useCustomerDownloadCodePage';

export function resolveDownloadTheme(
  session: CustomerSessionPassData
): SessionPassTheme {
  const theme = resolveSessionPassTheme(
    session.styleProfile,
    session.baseTheme
  );
  const defaultFont = "'Manrope', var(--Global--font)";
  return {
    ...theme,
    displayFont:
      theme.displayFont === 'Arial, sans-serif'
        ? defaultFont
        : theme.displayFont,
    bodyFont:
      theme.bodyFont === 'Arial, sans-serif' ? defaultFont : theme.bodyFont,
  };
}
